import general from './general.json';

const English = {
	general
};

export default English;
